import { Condition } from '@medplum/fhirtypes';
import { FC } from 'react';
import { getDisplayString } from '@medplum/core';
import { ResourceListSection } from '../shared/ResourceListSection';
import { ResourceListSectionConfig } from '../shared/ResourceListSectionConfig';
import { ConditionListItem } from '../../../examination/conditions/ConditionListItem';
import { conditionToInputItem } from '@/utils/condition.utils';
import { createActiveFilter } from '../shared/resource-sort-utils';

// -----------------------------------------------------------------------------
export interface ProblemListProps {
  readonly problems: Condition[];
}

// -----------------------------------------------------------------------------
const conditionConfig: ResourceListSectionConfig<Condition> = {
  titleKey: 'summaryPage.summary.conditions.title',
  noneKey: 'summaryPage.summary.conditions.none',
  noResourcesKey: 'summaryPage.summary.conditions.none',

  sortResources: (conditions) => {
    const activeFilter = createActiveFilter<Condition>(
      (c) => c.clinicalStatus?.coding?.[0]?.code
    );
    return activeFilter(conditions).sort((a, b) =>
      (b.onsetDateTime ?? '').localeCompare(a.onsetDateTime ?? '')
    );
  },

  getDisplayDate: (condition) => condition.onsetDateTime || '',

  getDisplayName: (condition) =>
    condition.code?.coding?.[0]?.display ||
    condition.code?.text ||
    getDisplayString(condition),

  getStatusLabel: (condition, t) =>
    t(
      `diagnosis.clinicalStatus.${condition.clinicalStatus?.coding?.[0]?.code}`,
      {
        defaultValue: condition.clinicalStatus?.coding?.[0]?.display,
      }
    ),

  renderItem: (condition) => (
    <ConditionListItem
      condition={conditionToInputItem(condition)}
      onAction={() => {}}
      hideActions
    />
  ),
};

// -----------------------------------------------------------------------------
export const ProblemList: FC<ProblemListProps> = ({ problems }) => {
  return (
    <ResourceListSection<Condition>
      resources={problems}
      config={conditionConfig}
    />
  );
};
